import type { CredentialRevealPending } from './types';

/**
 * Both secret-reveal endpoints (Credentials, Facebook) answer 2xx either way:
 * with the secret, or with a filed approval request. This is the discriminator
 * every caller has to go through before touching the payload.
 */
export function isRevealPending<T extends object>(
  res: T | CredentialRevealPending,
): res is CredentialRevealPending {
  return (res as CredentialRevealPending).pending_approval === true;
}
